import React, { useContext } from 'react'
import UserContext from 'src/contexts/UserContext'
import SessionContext from 'src/contexts/SessionContext'
import injectStyles, { StyledComponentProps } from 'react-jss'
import { Redirect, RouteComponentProps } from 'react-router';

export default function LandingPage(props: RouteComponentProps) {
  const session = useContext(SessionContext)
  if (session.token === undefined || props.location.pathname) {
    return <Redirect to='/login' />
  }
  return (
    <>
      <div>Landing page!</div>
    </>
  )
}